document.addEventListener('DOMContentLoaded', function() {
  // Modal functionality
  const btn = document.getElementById('enableMobileBtn');
  const productMainSection = document.querySelector('.product-section.product-bundle');

  if (btn && productMainSection) {
    btn.addEventListener('click', function() {
      productMainSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  // Cart bar functionality
  window.updateCartBarState = function(isAvailable, variantId) {
    const cartBarForms = document.querySelectorAll('.cart-bar__submit.product__submit.product__submit--spb, .secondary.product__submit');
    if (!cartBarForms.length) return;

    cartBarForms.forEach((cartBarForm) => {
      const addToCartButton = cartBarForm.querySelector('.add-to-cart-product');
      const mobileButton = cartBarForm.querySelector('.enable-mobile');

      if (!addToCartButton) return;

      const btnText = addToCartButton.querySelector('.btn__text');
      const mobileBtnText = mobileButton?.querySelector('.btn__text');

      if (!btnText) return;

      if (isAvailable) {
        addToCartButton.classList.remove('notify-me');
        addToCartButton.classList.remove('add-to-cart-product--notify');
        btnText.innerHTML = 'Add to Cart';
        addToCartButton.removeAttribute('id');
        addToCartButton.removeAttribute('data-variant-id');
        addToCartButton.setAttribute('data-add-to-cart', '');

      } else {
        addToCartButton.classList.add('notify-me');
        addToCartButton.classList.add('add-to-cart-product--notify');
        btnText.innerHTML = 'Notify Me';
        addToCartButton.setAttribute('data-variant-id', variantId);
        addToCartButton.setAttribute('id', 'BIS_trigger');
        addToCartButton.removeAttribute('data-add-to-cart');
      }

      const btnSubmitTexts = cartBarForm.querySelectorAll('.add-to-cart-product .btn__text');
      btnSubmitTexts.forEach(btnSubmitText => {
        btnSubmitText.innerHTML = isAvailable ? 'Add to Cart' : 'Notify Me';
      });
    });
  };

  document.addEventListener('cart-bar:variant:change', function(event) {
    if (event.detail && event.detail.variant) {
      const { available, id } = event.detail.variant;
      window.updateCartBarState(available, id);
    }
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const button = mutation.target;
        if (button.classList.contains('add-to-cart-product')) {
          const isNotifyMe = button.classList.contains('notify-me');
          const btnText = button.querySelectorAll('.btn__text');
          if (btnText) {
            btnText.forEach(btnSubmitText => {
              btnSubmitText.innerHTML = isNotifyMe ? 
                'Notify Me' : 
                'Add to Cart';
            });
          }
        }
      }
    });
  });

  const cartBar = document.querySelector('.cart-bar');
  if (cartBar) {
    observer.observe(cartBar, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  const initialVariant = document.querySelector('.cart-bar .variant-picker-select:checked, .cart-bar .radio__button input:checked');
  if (initialVariant) {
    const isAvailable = !initialVariant.closest('.radio__button')?.querySelector('.sold-out');
    const variantId = initialVariant.value || initialVariant.getAttribute('data-product-variant');
    updateCartBarState(isAvailable, variantId);
  }
}); 